<template>
  <div class="col-6 d-flex align-items-center" :class="'order-info' + dataClassName">
    <div class="icon-position">
      <slot name="icon-item"></slot>
    </div>
    <div class="ms-4">
      <div class="font-medium font-weight-300">{{ $t(translateKey) }}</div>
      <h5 class="font-weight-600 order-info__data-item m-0">
        <slot name="order-info"></slot>
      </h5>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import './orderInfoItemWrapper.scss';

export default defineComponent({
  name: 'OrderInfoItemWrapperComponent',
  components: {},

  props: {
    dataClassName: {
      type: String,
    },
    translateKey: {
      type: String,
    }
  },

  data() {
    return {

    }
  }


})
</script>

<style scoped>

.icon-position {
  align-self: flex-start;
  margin-top: 10px;
}

</style>